import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useHistory, withRouter } from "react-router-dom";
import { Spinner } from "reactstrap";

import { scrollToTop } from "../Utilities/ScrollToTop";

import "./PageDisplay.scss";

const PageDisplay = (props) => {
  const { children, documentTitle, pageTitle, error, reload, customHeaderButton, isLoading } = props;
  const [scrollTop, setScrollTop] = useState(0);
  const history = useHistory();

  useEffect(() => {
    scrollToTop();
    window.addEventListener("scroll", setScrollPos);
    return () => window.removeEventListener("scroll", setScrollPos);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    document.title = documentTitle;
  }, [documentTitle]);

  const setScrollPos = () => {
    setScrollTop(window.scrollY);
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <div className="page-display">
      {isLoading ? (
        <Spinner size="md" color="orange" />
      ) : (
        <>
          <h2 className="page-display__title">
            <span className="page-title">{pageTitle ?? "-"}</span>
            {typeof reload !== "undefined" && (
              <span onClick={() => reload(true)} className={"reload-data loading-" + isLoading}>
                <i className="fas fa-sync-alt"></i>
              </span>
            )}
            {typeof customHeaderButton !== "undefined" && (
              <span onClick={customHeaderButton.handler} className={customHeaderButton.className}>
                {customHeaderButton.content}
              </span>
            )}
            <button onClick={goBack} className="btn btn-outline-secondary btn-sm back-btn">
              <i className="fas fa-angle-left" />{" "}
              <FormattedMessage id="goback" defaultMessage="Go Back" description="Go Back Button" />
            </button>
          </h2>
          <div className="page-display__content">
            {children}
            <h3 className="page-error">{error?.message}</h3>
          </div>
          {scrollTop > 50 && (
            <button onClick={scrollToTop} className="btn-scroll-up btn btn-secondary">
              <i className="fas fa-arrow-up" />
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default withRouter(PageDisplay);
